<script lang="ts">
	import ReviewsWidget from '$lib/review/reviewsWidget.svelte';
	import type { ISbStoryData } from '@storyblok/js';
	import PageGrid from '../components/pageGrid.svelte';
	import { editable } from '../editable';

	interface Props {
		content: ISbStoryData<{
			hideHeadline: boolean;
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<PageGrid>
	<div class="col-span-full" use:editable={content}>
		<ReviewsWidget hideHeadline={content.hideHeadline} />
	</div>
</PageGrid>
